module.exports = __webpack_public_path__ + "static/media/Dr_Monique_du_REAU.2edad45a.jpg";